goog.provide("shadow.js.shim.module$dayjs$locale$zh_hk");
goog.provide("module$shadow_js_shim_module$dayjs$locale$zh_hk");
shadow.js.shim.module$dayjs$locale$zh_hk = shadow.js.nativeProvides["dayjs/locale/zh-hk"] = require("dayjs/locale/zh-hk");
module$shadow_js_shim_module$dayjs$locale$zh_hk.default = shadow.js.shim.module$dayjs$locale$zh_hk;
